<template>
    <div>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/ Template</span>
        </v-row>
        <br />
        <v-card>
            <v-col cols="12" sm="12" md="12">
                <center class="heading">
                    <h3>Template</h3>
                </center>
                <v-row justify="center">
                    <v-row class="justify-center pt-5">
                        <span lg="4" sm="12" cols="12" class="margin" v-for="link in link_data" :key="link.link">
                            <router-link :to="{ name: link.link}" class="link">
                                <v-icon class="icon">{{ link.icon }}</v-icon>
                                <span>{{ link.name }}</span>
                            </router-link>
                        </span>
                    </v-row>
                </v-row>
            </v-col>
        </v-card>
        <br />
        <router-view />
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css";
    export default {
        data: () => ({
            link_data: [
                {
                    link: "coe-create-template",
                    icon: "mdi-copyright",
                    name: "Template Master",
                },
                {
                    link: "coe-define-template",
                    icon: "mdi-cogs",
                    name: "Template Creation",
                },
                {
                    link: "coe-offer-template",
                    icon: "mdi-offer",
                    name: "Apply template",
                },
                 {
                    link: "question-paper-template-status",
                    icon: "mdi-offer",
                    name: "Verify template",
                },
            ],
            activeClass: "active",
        }),
        computed: {
            currentPage() {
                return this.$route.path;
            },
        },
        mounted() {
            this.$router.push({ name: "coe-create-template" });
        },
    };
</script>
<style scoped>
    .active {
        /* background-color: hsla(190, 99%, 30%, 1); */
        background-color: #add8e630;
        color: hsla(190, 99%, 30%, 1);
        box-shadow: 8px 8px 8px gray;
    }
    .box {
        background-color: #cbe6f0;
        margin: 8px !important;
        padding: 10px;
        border: 3px solid hsla(190, 99%, 30%, 1) !important;
        border-radius: 40px;
    }
    .link {
        text-decoration: none;
        border: 3px solid hsl(190deg 99% 30% / 64%) !important;
        padding: 1rem;
        border-radius: 30px;
        color: hsla(190, 99%, 30%, 1);
        font-size: 15px;
    }
    .margin {
	margin: 30px;
    }
    @media only screen and (max-width: 600px) {
	.margin {
		margin: 20px 20px 20px 0px;
	}
}
</style>
